import cn from 'classnames';
import { MdOutlineShowChart } from 'react-icons/md';

interface ChartPlaceholderProps {
  message: string;
  className?: string;
}

// The empty/error state every dashboard renderer shows in place of a chart.
export const ChartPlaceholder = ({ message, className }: ChartPlaceholderProps) => (
  <div className={cn('chart-renderer', 'chart-renderer-placeholder', className)}>
    <MdOutlineShowChart className='chart-renderer-placeholder-icon' />
    <p className='chart-renderer-placeholder-message'>{message}</p>
  </div>
);
